// extracted by mini-css-extract-plugin
export default {"container":"custom-inner-module__container___GmqPX","title":"custom-inner-module__title___hNtTe","description":"custom-inner-module__description___PhC7y"};